import { createAction } from 'redux-actions';

export const userProfileLoading = createAction('USER_PROFILE_LOAD');
export const userProfileLoadingSucceeded = createAction(
    'USER_PROFILE_LOAD_SUCCESS',
);
export const userProfileLoadingFailed = createAction('USER_PROFILE_LOAD_FAIL');
export const userProfileChange = createAction('USER_PROFILE_CHANGE');
export const currentUserModelChange = createAction('CURRENT_USER_MODEL_CHANGE');

export const partnerRequestSending = createAction('PARTNER_REQUEST_SEND');
export const partnerRequestSendingSucceeded = createAction(
    'PARTNER_REQUEST_SEND_SUCCESS',
);
export const partnerRequestSendingFailed = createAction(
    'PARTNER_REQUEST_SEND_FAIL',
);

export const setCaptcha = createAction('AUTH_REQUEST_CAPTCHA');
export const setCaptchaImageUrl = createAction(
    'AUTH_REQUEST_CAPTCHA_IMAGE_URL',
);
export const clearCaptcha = createAction('AUTH_REQUEST_CAPTCHA_CLEAR');
export const clearCaptchaImageUrl = createAction(
    'AUTH_REQUEST_CAPTCHA_IMAGE_URL_CLEAR',
);

export const partnerRequestLoading = createAction('PARTNER_REQUEST_LOADING');
export const partnerRequestLoadingSucceeded = createAction(
    'PARTNER_REQUEST_LOADING_SUCCESS',
);
export const partnerRequestLoadingFailed = createAction(
    'PARTNER_REQUEST_LOADING_FAIL',
);

export const signUpRequest = createAction('SIGNUP_REQUEST');
export const signUpRequestSucceeded = createAction('SIGNUP_REQUEST_SUCCESS');
export const signUpRequestFailed = createAction('SIGNUP_REQUEST_FAIL');
